module.exports = __webpack_public_path__ + "img/HeadSpin.9488b88a.jpg";